import { __decorate } from "tslib";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    /**
     * yxtf-table height / maxHeight 的设置存在 bug，通过以下方式进行 hack
     * 1. 初始时 height/maxHeight = undefined，设置有效值后表格更新正确，之后将值重设为 undefined 表格将不会更新
     * 2. 如果将 height/maxHeight 默认设置为空字符串，则表格在挂载渲染时会报错（但是不影响渲染）
     */
    this.tableHeight = void 0;
    this.tableMaxHeight = void 0;
  }
  get tableData() {
    return Array.isArray(this.data) ? this.data : [];
  }
  handleHeightChange() {
    this.tableHeight = this.height || '';
    this.tableMaxHeight = this.maxHeight || '';
  }
  created() {
    this.tableHeight = this.height;
    this.tableMaxHeight = this.maxHeight;
  }
};
default_1.componentName = 'AmFeSlotTable';
__decorate([Prop(Array)], default_1.prototype, "data", void 0);
__decorate([Prop(String)], default_1.prototype, "height", void 0);
__decorate([Prop(String)], default_1.prototype, "maxHeight", void 0);
__decorate([Prop(String)], default_1.prototype, "size", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "stripe", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "border", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], default_1.prototype, "showHeader", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "virtual", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "fold", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "foldLazy", void 0);
__decorate([Prop(Function)], default_1.prototype, "foldLazyMethod", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "loading", void 0);
__decorate([Prop(Number)], default_1.prototype, "rowHeight", void 0);
__decorate([Prop(String)], default_1.prototype, "rowKey", void 0);
__decorate([Prop(Object)], default_1.prototype, "defaultSort", void 0);
__decorate([Prop(Object)], default_1.prototype, "customColumnProps", void 0);
__decorate([Watch('height'), Watch('maxHeight')], default_1.prototype, "handleHeightChange", null);
default_1 = __decorate([Component({
  name: 'AmFeSlotTable'
})], default_1);
export default default_1;